<template>
    <div>
        <el-row>
            <h3>Escalation Dashboard</h3>
        </el-row>
        <el-card class="box-card" style="margin-bottom: 20px">
            <el-row style="display: flex; justify-content: flex-end; margin-right: 35px;">
                <el-col :span="4">
                    <el-button type="primary" @click="toggleGrouping">{{ isGrouped ? 'Ungroup' : 'Group' }}</el-button>
                </el-col>
                <el-col :span="4">
                    <el-button type="primary" @click="toggleAllNextStepComments">{{ allCommentNextStepVisible  ? 'Hide All Next Step Comments' : 'Show All Next Step Comments' }}</el-button>
                </el-col>
                <el-col :span="10">

                </el-col>
                <el-col :span="8">
                    <el-input v-model="filter.customer"
                              placeholder="Customer Number"
                              prefix-icon="el-icon-search"
                              clearable></el-input>
                </el-col>
                <el-col :span="8">
                    <el-input v-model="filter.ticket"
                              placeholder="Ticket Number"
                              prefix-icon="el-icon-search"
                              clearable></el-input>
                </el-col>
                <el-col :span="8">
                    <el-input v-model="filter.serialNumber"
                              placeholder="Serial Number"
                              prefix-icon="el-icon-search"
                              clearable></el-input>
                </el-col>
                <el-col :span="8">
                    <el-date-picker v-model="filter.dateFrom"
                                    type="date"
                                    placeholder="From Raised On Date"
                                    style="width:100%;"></el-date-picker>
                </el-col>
                <el-col :span="8">
                    <el-date-picker v-model="filter.dateTo"
                                    type="date"
                                    placeholder="To Raised On Date"
                                    style="width:100%;"></el-date-picker>
                </el-col>
            </el-row>
        </el-card>
        
        <el-card class="box-card">
            <strong>Creation Date</strong>
            <el-row style="margin-bottom: 10px; justify-content: flex-end; margin-right: 35px;">
                <el-col :span="3">
                    <el-row style="margin-left: 10px; margin-bottom: 5px;">
                        <span class="filterClass">6+ Days</span>
                    </el-row>
                    <colored-box :number="escalationCriticalCount" boxColor="#f2999a" @click="handleBoxClick('critical')"></colored-box>
                </el-col>
                <el-col :span="3">
                    <el-row style="margin-left: 10px; margin-bottom: 5px;">
                        <span class="filterClass">4-6 Days</span>
                    </el-row>
                    <colored-box :number="escalationWarningCount" boxColor="#fdff65" @click="handleBoxClick('warning')"></colored-box>
                </el-col>
                <el-col :span="3">
                    <el-row style="margin-left: 10px; margin-bottom: 5px;">
                        <span class="filterClass">1-4 Days</span>
                    </el-row>
                    <colored-box :number="escalationNewCount" boxColor="#f0f9eb" @click="handleBoxClick('new')"></colored-box>
                </el-col>
                <el-col :span="3">
                    <el-row style="margin-left: 10px; margin-bottom: 5px;">
                        <span class="filterClass">Sales Follow Up</span>
                    </el-row>
                    <colored-box :number="escalationSalesFollowUpCount" boxColor="#efe4b6" @click="handleBoxClick('salesFollowUp')"></colored-box>
                </el-col>
                <el-col :span="3">
                    <el-row style="margin-left: 10px; margin-bottom: 5px;">
                        <span class="filterClass">All</span>
                    </el-row>
                    <colored-box :number="escalationTotalCount" boxColor="#a6a5a4" @click="handleBoxClick('total')"></colored-box>
                </el-col>
            </el-row>
        </el-card>
        
        <template v-if="isGrouped">
            <el-row v-for="(tickets, customer) in groupedTickets" :key="customer">
                <el-col>
                    <h4>{{ customer }}</h4>
                    <el-table size="mini"
                              :data="tickets"
                              v-loading="loading"
                              class="tickets-table"
                              @sort-change="sortServiceTickets"
                              @row-click="handleRowClick"
                              :row-class-name="tableRowEscalationTime"
                              :row-key="rowKey"
                              :expand-row-keys="allCommentsNextStepVisible ? tickets.map(ticket => ticket.id) : []">
                        <el-table-column type="expand"  width="20">
                            <template slot-scope="scope">
                                <div>
                                    <p><strong>Next Step:</strong></p>
                                    <p>{{ scope.row.escalationCommentNextStep }}</p>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="id"
                                         label="Ticket #"
                                         sortable="custom"
                                         width="75">
                        </el-table-column>
                        <el-table-column prop="customer"
                                         label="Customer #"
                                         sortable="custom"
                                         width="115"></el-table-column>
                        <el-table-column label="Raised On"
                                         sortable="custom"
                                         v-if="width > 768"
                                         width="85">
                            <template slot-scope="scope">
                                {{scope.row.raisedOn | datetime}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="daysSinceRaised"
                                         label="Days"
                                         sortable="custom"
                                         :formatter="daysSinceRaisedFormatter"
                                         width="55"></el-table-column>
                        <el-table-column prop="daysSinceEscalation"
                                         label="Days Escalation"
                                         sortable="custom"
                                         :formatter="daysSinceRaisedFormatter"
                                         width="200"></el-table-column>
                        <el-table-column prop="lastComment"
                                         label="Last Comment"
                                         sortable="custom"
                                         v-if="width > 768"
                                         min-width="250">
                            <div slot-scope="scope" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; ">
                                {{scope.row.lastComment}}
                            </div>
                        </el-table-column>
                        <el-table-column prop="lastUpdatedTime"
                                         label="Last Update"
                                         sortable="custom"
                                         v-if="width > 768"
                                         width="90">
                            <template slot-scope="scope">
                                {{scope.row.lastUpdatedTime | datetime}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="lastUpdatedBy"
                                         label="Last Update by"
                                         sortable="custom"
                                         v-if="width > 768"
                                         width="110"></el-table-column>
                        <el-table-column label="Part Required" v-if="width > 768" width="85"></el-table-column>
                        <el-table-column label="Tracking #" v-if="width > 768" width="75"></el-table-column>
                        <el-table-column label="Serial #" v-if="width > 768" width="75"
                                        prop="serialNumber" 
                                        ></el-table-column>
                        <el-table-column prop="serviceCompany"
                                         label="Service Company"
                                         sortable="custom"
                                         v-if="width > 768"
                                         width="140">
                        </el-table-column>
                    </el-table>
                </el-col>
            </el-row>
        </template>
        <template v-else>
            <el-table size="mini"
                      :data="tickets"
                      v-loading="loading"
                      class="tickets-table"
                      @sort-change="sortServiceTickets"
                      @row-click="handleRowClick"
                      :row-class-name="tableRowEscalationTime"
                      :row-key="rowKey"
                      :expand-row-keys="allCommentsNextStepVisible ? tickets.map(ticket => ticket.id) : []">
                <el-table-column type="expand" width="20">
                    <template slot-scope="scope">
                        <div>
                            <p><strong>Last Comment:</strong></p>
                            <p>{{ scope.row.lastComment }}</p>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="id"
                                 label="Ticket #"
                                 sortable="custom"
                                 width="75">
                </el-table-column>
                <el-table-column prop="customer"
                                 label="Customer #"
                                 sortable="custom"
                                 width="115"></el-table-column>
                <el-table-column label="Raised On"
                                 sortable="custom"
                                 v-if="width > 768"
                                 width="85">
                    <template slot-scope="scope">
                        {{scope.row.raisedOn | datetime}}
                    </template>
                </el-table-column>
                <el-table-column prop="daysSinceRaised"
                                 label="Days"
                                 sortable="custom"
                                 :formatter="daysSinceRaisedFormatter"
                                 width="55"></el-table-column>
                <el-table-column prop="lastComment"
                                 label="Last Comment"
                                 sortable="custom"
                                 v-if="width > 768"
                                 min-width="250">
                    <div slot-scope="scope" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; ">
                        {{scope.row.lastComment}}
                    </div>
                </el-table-column>
                <el-table-column prop="lastUpdatedTime"
                                 label="Last Update"
                                 sortable="custom"
                                 v-if="width > 768"
                                 width="90">
                    <template slot-scope="scope">
                        {{scope.row.lastUpdatedTime | datetime}}
                    </template>
                </el-table-column>
                <el-table-column prop="lastUpdatedBy"
                                 label="Last Update by"
                                 sortable="custom"
                                 v-if="width > 768"
                                 width="110"></el-table-column>
                <el-table-column label="Part Required" v-if="width > 768" width="85"></el-table-column>
                <el-table-column label="Tracking #" v-if="width > 768" width="75"></el-table-column>
                <el-table-column label="Serial #" v-if="width > 768" width="75"
                                prop="serialNumber" 
                                ></el-table-column>
                <el-table-column prop="serviceCompany"
                                 label="Service Company"
                                 sortable="custom"
                                 v-if="width > 768"
                                 width="140"></el-table-column>
                <el-table-column prop="status" label="Status" sortable="custom" width="80">
                    <template slot-scope="scope">
                        {{ scope.row.status }}
                    </template>
                </el-table-column>
            </el-table>
            </template>
            <escalation-list-details-dialog :ticketId="ticketToEdit"
                                            @dialogClosed="editFinished"
                                            :visible="dialogVisible">
            </escalation-list-details-dialog>
        </div>
    </template>
    <script>
        import api from "../api";
        import ColoredBox from '../../../app/shared/components/ColoredBox.vue'
        import EscalationListDetailsDialog from "./EscalationListDetailsDialog";

        export default {
            name: "escalation-ticket-list",
            components: {
                ColoredBox,
                EscalationListDetailsDialog
            },
            data() {
                return {
                    tickets: [],
                    loading: true,
                    sorting: {},
                    currentPage: 1,
                    total: 0,
                    escalationWarningCount: 0,
                    escalationCriticalCount: 0,
                    escalationNewCount: 0,
                    escalationTotalCount: 0,
                    escalationSalesFollowUpCount: 0,
                    ticketToEdit: null,
                    dialogVisible: false,
                    filteredBy: "",
                    width: window.innerWidth,
                    isGrouped: true, // Add this line
                    allCommentsNextStepVisible: false,
                    filter: {
                        type: this.$route.params.status || null,
                        customer: "",
                        ticket: "",
                        serviceCompany: "",
                        dateFrom: null,
                        dateTo: null,
                        serialNumber: "",
                    },
                }
            },
            watch: {
                filter: {
                    deep: true,
                    handler: function () {
                        if (this.filter.status === null && this.$route.params.status != null) {
                            window.location.href = "/#/escalation-tickets";
                        }
                        this.loadTickets();
                    }
                }
            },
            created() {
                this.loadTickets();
            },
            mounted() {
                window.addEventListener('resize', this.updateDimensions);
            },
            beforeDestroy() {
                window.removeEventListener('resize', this.updateDimensions);
            },
            computed: {
                groupedTickets() {
                    return this.tickets.reduce((groups, ticket) => {
                        (groups[ticket.customer] = groups[ticket.customer] || []).push(ticket);
                        return groups;
                    }, {});
                }
            },
            methods: {
                toggleAllNextStepComments() {
                    this.allCommentsNextStepVisible = !this.allCommentsNextStepVisible;
                },
                toggleGrouping() {
                    this.isGrouped = !this.isGrouped;
                },
                updateDimensions() {
                    this.width = window.innerWidth;
                },
                handleBoxClick(type) {
                    this.filteredBy = type;
                    this.loadTickets();
                },
                loadTickets() {
                    this.loading = true;
                    api.getEscalationCounts()
                        .then(response => {
                            this.escalationWarningCount = response.data.escalationWarningCount;
                            this.escalationCriticalCount = response.data.escalationCriticalCount;
                            this.escalationNewCount = response.data.escalationNewCount;
                            this.escalationTotalCount = response.data.escalationTotalCount;
                            this.escalationSalesFollowUpCount = response.data.escalationSalesFollowUpCount;
                        });
                    api.getTickets(this.filteredBy, this.filter, this.currentPage, this.sorting)
                        .then(response => {
                            this.loading = false;
                            this.tickets = response.data.items;
                            this.total = response.data.total;
                        });
                },
                handleCurrentChange(page) {
                    this.currentPage = page;
                    this.loadTickets();
                },
                sortServiceTickets(sort) {
                    let sortBy = sort.prop;
                    if (!sortBy && sort.column != null) {
                        sortBy = sort.column.label;
                    }
                    let sortOrder = sort.order;
                    this.sorting = {
                        sortBy,
                        sortOrder
                    };
                    if (this.currentPage === 1) {
                        this.loadTickets();
                    } else {
                        this.currentPage = 1;
                    }
                },
                truncateComment(row, column, cellValue) {
                    const limit = 80;
                    return this.truncate(cellValue, limit);
                },
                truncate(value, limit) {
                    if (!value) return '';
                    if (value.length <= limit) return value;
                    return value.substring(0, limit) + '...';
                },
                formattedHour(decimalHour) {
                    let hour = Math.floor(decimalHour);
                    let minute = Math.round((decimalHour - hour) * 60);
                    minute = (minute < 10 ? '0' : '') + minute;
                    return `${hour} hrs: ${minute} min`;
                },
                tableRowEscalationTime({ row, column }) {
                    if (row.status == 'SalesFollowUp')
                        return 'sales-followup-row';
                    if (row.daysSinceRaised >= 0 && row.daysSinceRaised <= 4) {
                        return 'success-row';
                    } else if (row.daysSinceRaised > 4 && row.daysSinceRaised <= 6) {
                        return 'warning-row';
                    } else if (row.daysSinceRaised > 6) {
                        return 'error-row';
                    } else {
                        return 'default-row';
                    }
                },
                daysSinceRaisedFormatter(row, column, cellValue) {
                    return cellValue === -1 ? '' : cellValue;
                },
                editFinished() {
                    this.ticketToEdit = null;
                    this.dialogVisible = false;
                },
                handleRowClick(row) {
                    this.ticketToEdit = row.id;
                    this.dialogVisible = true;
                },
                rowKey(row) {
                    return row.id;
                }
            }
        }
    </script>
    <style>
        .el-table .warning-row {
            background: #fdff65;
        }

        .el-table th > .cell{
            padding: 0 2px;
        }

        .el-table .cell{
            padding-left: 0;
        }

        .el-table .caret-wrapper {
            width: 16px;
        }

        .el-table--scrollable-x .el-table__body-wrapper {
            overflow-x: auto;
        }

        .el-table .success-row {
            background: #f0f9eb;
        }

        .el-table .error-row {
            background: #f2999a
        }

        .el-table .sales-followup-row {
            background: #efe4b6;
        }

        .filterClass {
            font-size: 14px;
            color: #000;
        }
    </style>



// WEBPACK FOOTER //
// ClientApp/globalapp/escalationdashboard/components/EscalationList.vue